// NOTE: For some reason using RichType imported from @toolpath/tools.
// It appears that Next.js's transpilation gets in the way. next-transpile-modules *should* solve it, but I can't get that to work.
// Need to get to the bottom of this later, but for now, keeping a copy of the type here is a workaround
//export { InstanceProperties, RichType } from '@toolpath/tools/dist/rich/rich-type'

import { Metadata, MetadataWithId, getDefaults } from './metadata'

export class RichType {
  static getMetadata(): MetadataWithId[] {
    return Object.keys(this)
      .filter((key) => key.endsWith('_metadata'))
      .map((metadataKey) => {
        const id = metadataKey.replace('_metadata', '')
        const metadata = (this as any)[metadataKey]
        return { id, ...metadata }
      })
  }

  static getMetadataMap(): Record<string, Metadata> {
    return Object.keys(this)
      .filter((key) => key.endsWith('_metadata'))
      .reduce((map, key) => {
        const property = key.replace('_metadata', '')
        map[property] = (this as any)[key]
        return map
      }, {} as Record<string, any>)
  }

  static getDefaults(metric: boolean) {
    return getDefaults(this.getMetadata(), metric)
  }
}

type NonFunctionPropertyNames<T> = {
  [K in keyof T]: T[K] extends Function ? never : K
}[keyof T]

export type InstanceProperties<T> = Pick<T, NonFunctionPropertyNames<T>>
